























import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import Focusable from '@/mixins/Focusable'
import config from '@/config'

@Component
export default class AgreementBlock extends Mixins(Vue, Validatable, Focusable) {
	@Prop({ default: false }) readonly value!: boolean
	private open: boolean = false

	private get privacyPolicyDescription() {
		if (!config.privacyPolicy) return null
		return config.privacyPolicy.description
	}

	private get acceptLabel() {
		if (!config.privacyPolicy) return null
		return config.privacyPolicy.label
	}

	get checkboxState() {
		return typeof this.errorMsg !== 'string' ? null : false
	}

	get checked() {
		return this.value
	}

	set checked(value: boolean) {
		this.$emit('input', value)
	}

	@Watch('value')
	onValueChanged() {
		this.validate()
	}

	onChange() {
		this.$emit('input', !this.value)
	}

	// fix for missing translations
	created() {
		if (!config.privacyPolicy || config.privacyPolicy.description.split(' ').length <= 1) {
			this.open = true
		}
	}
}
